import React, { Component } from "react";

import Header from "../components/HeaderSection/Header";

class ThemeTwo extends Component {
  render() {
    return (
      <div className="homepage-2">
        {/*====== Scroll To Top Area Start ======*/}
        <div id="scrollUp" title="Scroll To Top">
          <i className="fas fa-arrow-up" />
        </div>
        {/*====== Scroll To Top Area End ======*/}
        <div className="main">
        </div>
      </div>
    );
  }
}

export default ThemeTwo;
